module.exports = __webpack_public_path__ + "img/speaker-MaryPilon.65729350.png";